module.exports = __webpack_public_path__ + "static/ebr-invite-7c7f01f3059147f1fa45118dfad2f87e.jpg";